export function hasSlot(slots, slot_name) {
  return slots?.[slot_name] !== undefined;
}
